<template>
  <v-dialog v-model="internalIsOpen" max-width="400px">
    <v-card>
      <v-card-title>
       Enviar invitación
      </v-card-title>
      <v-card-text class="bg-surface-light pt-4">
El recibo de pago será enviado al correo electrónico ingresado.
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="sendEmail">
          <v-text-field v-model="email" label="Correo electrónico" :rules="[rules.required, rules.email]"
            required></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeModal">Cancelar</v-btn>
        <v-btn   :disabled="isSending" color="blue darken-1" text @click="sendEmail">  {{ isSending ? 'Enviando...' : 'Enviar' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
// import { EventBus } from '@/functions/event-bus'

export default {
  computed: {
    ...mapGetters(['getEmail'])
  },
  props: {
    isOpen: Boolean,
    item: Object
  }, 
  watch: {
    isOpen(val) {
      this.internalIsOpen = val;
      if (val) this.localItem = { ...this.item };
      this.email = this.localItem.Email ? this.localItem.Email : this.getEmail;
    },
    internalIsOpen(val) {
      this.$emit("close", val);
    },
  },
  data() {
    return {    
      isSending: false, // nuevo
      internalIsOpen: this.isOpen,
      localItem: { ...this.item },
      dialog: false,
      valid: false,
      email: '',
      subject: '',
      message: '',
      rules: {
        required: value => !!value || 'Requerido.',
        email: value => {
          const pattern = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/
          return pattern.test(value) || 'Correo electrónico inválido.'
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.internalIsOpen = false;
    },
    sendEmail() {
      if (this.$refs.form.validate()) {
        this.isSending = true;
        this.$http.get(`file/${this.localItem.idpago}/RECIBO_PAGO/${this.email}/correo`)
          .then(response => {
            if (response.status === 200) {
            this.$swal.fire({
              toast: true,
              position: 'top-end',
              title: 'Correcto',
              text: 'Correo enviado.',
              icon: 'success',
              confirmButtonText: 'Cerrar',
              showCloseButton: false,
              showConfirmButton: true,
              timer: 4000,
              width: '40%',  // Más ancho
              backdrop: false, // Evita que la alerta haga scroll al inicio
            })
            // Cerrar modal solo si fue exitoso
            this.closeModal();
            this.isSending = false
            }
          })
          .catch(() => {
            this.$swal.fire({
              position: 'center',
              // title: 'Valida',
              //text: 'Se genero un error',
              html: `Ocurrio un error, el cual ya fue reportado. intente mas tarde.`,
              icon: 'error',
              confirmButtonText: 'Cerrar',
              showCloseButton: true,
              showConfirmButton: true,
              //timer: 1500,
              width: '400px',
              backdrop: false, // Evita que la alerta haga scroll al inicio
            });
        }).finally(() => {
             this.isSending = false;
        });
      }
    }
  }
}
</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>